// toggle-hash.js
'use strict';

(function () {
  // Initiera alla element med data-toggle-hash
  function initToggleHash() {
    const toggleElements = document.querySelectorAll('[data-toggle-hash]');

    if (!toggleElements.length) {
      return;
    }

    toggleElements.forEach(el => {
      const defaultText = el.textContent;
      const altText = el.getAttribute('data-toggle-hash') || defaultText;

      el.addEventListener('click', e => {
        e.preventDefault();

        const clickedHash = el.getAttribute('href') || '#';
        const currHash = window.location.hash;

        if (clickedHash === currHash) {
          // Clear hash
          history.pushState("", document.title, window.location.pathname + window.location.search);
          el.textContent = defaultText;

          document.documentElement.classList.remove('hash-active', 'hash-active-' + clickedHash.substring(1));
        } else {
          // Set hash
          window.location.hash = clickedHash;
          el.textContent = altText;

          document.documentElement.classList.add('hash-active', 'hash-active-' + clickedHash.substring(1));
        }
      });
    });
  }

  // Kör init när DOM är redo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToggleHash);
  } else {
    initToggleHash();
  }
})();
